import { jsxs as r, jsx as o } from "react/jsx-runtime";
function t(n) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: [
        /* @__PURE__ */ o("path", { d: "M6.66663 3H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ o("path", { d: "M6.66663 6.33334H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ o("path", { d: "M6.66663 9.66666H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ o("path", { d: "M6.66663 13H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M2 9.66666H4V10.6667L2 12.6667V13H4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M2.33337 3.66667L3.00004 3V6.33333M3.00004 6.33333H2.33337M3.00004 6.33333H3.66671",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        )
      ]
    }
  );
}
export {
  t as default
};
